import * as S from "./DataFlowItem.style";
import { ReactComponent as IconECS } from "../../../styles/assets/svg/icon_data_ecs.svg";
import { ReactComponent as IconSave } from "../../../styles/assets/svg/icon_data_save.svg";
import { ReactComponent as IconSend } from "../../../styles/assets/svg/icon_data_send.svg";
import { ReactComponent as IconReceived } from "../../../styles/assets/svg/icon_data_received.svg";

export interface DataFlowItemProps {
  status?: "normal" | "ready" | "errored";
  unit?: "ecs" | "save" | "send" | "received";
  active?: boolean;
  date?: Date;
}

export const DataFlowItem = ({
  status,
  unit,
  active,
  date,
}: DataFlowItemProps) => {
  return (
    <S.DataFlowItem>
      <S.FlowTileLabel>
        {unit !== "ecs" && <S.FlowLed status={status} />}

        {unit === "ecs" && "함정"}
        {unit === "save" && "수집"}
        {unit === "send" && "송신"}
        {unit === "received" && "육상"}
      </S.FlowTileLabel>

      <S.FlowTile unit={unit} active={active}>
        <div>
          <div>
            {unit === "ecs" && <IconECS />}
            {unit === "save" && <IconSave />}
            {unit === "send" && <IconSend />}
            {unit === "received" && <IconReceived />}
          </div>
        </div>
      </S.FlowTile>

      <S.FlowTimeTxt>{unit === "ecs" ? "-" : `${date}`}</S.FlowTimeTxt>
    </S.DataFlowItem>
  );
};
